import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Paragraph from "antd/es/typography/Paragraph";
import Underline from "@tiptap/extension-underline";

export const ReadOnlyEditor = ({ content, className }: { content: string; className?: string }) => {
    const editor = useEditor({
        extensions: [StarterKit, Underline],
        content: content || '',
        editable: false,
    });

    if (!editor) {
        return <Paragraph className={className || 'text-base font-normal text-gray-600 whitespace-pre-wrap'}>{content}</Paragraph>;
    }

    return <EditorContent editor={editor} readOnly className={className || 'text-base font-normal text-gray-600 whitespace-pre-wrap'} />;
};